/**
 * widgets/registry.apphost.tsx — AppHost widgety (2.1).
 * instances = list + detail lifecycle; lovable = import control panel.
 */
import { Server, Wand2 } from 'lucide-react';
import type { WidgetSpec } from './types';
import { InstancesPanel, LovablePanel } from '../pages/modules/apphost/panels';

export const APPHOST_WIDGETS: WidgetSpec[] = [
  {
    id: 'apphost.instances',
    title: 'AppHost instance',
    module: 'apphost',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Server,
    since: '2.1.0',
    component: InstancesPanel,
  },
  {
    id: 'apphost.lovable',
    title: 'Lovable imports',
    module: 'apphost',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Wand2,
    since: '2.1.0',
    component: LovablePanel,
  },
];
